import i18n from '~/translations';

export const BENEFITS_LIST = [
  {
    label: i18n.t('signUp.benefits.list.effortlessSetup', 'Effortless setup'),
  },
  {
    label: i18n.t('signUp.benefits.list.intuitiveInterface', 'Intuitive interface'),
  },
  {
    label: i18n.t('signUp.benefits.list.fastTestExecution', 'Fast test execution'),
  },
];
